<template>
  <generic-modal
    :title="$t('file')"
    icon="file"
    image="/images/icons/file.png"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
    :footer_buttons="footer_buttons"
  >
    <div class="ui form" ref="form">
      <div class="field">
        <label for="">{{ $t("file name") }}</label>
        <input type="text" name="file_name" v-model="file_name" />
      </div>
      <code-editor
        :title="$t('api code editor')"
        v-model="code"
        :show_format="true"
      />
      <div class="ui error message"></div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api } from "@/utils";
import GenericModal from "@/components/GenericModal";
import CodeEditor from "@/components/code_editor/Index";

export default {
  name: "APIManagerFileModal",
  components: {
    "generic-modal": GenericModal,
    CodeEditor,
  },
  props: {
    file_in: Object,
  },
  computed: {},
  data() {
    return {
      footer_buttons: [
        {
          icon: "trash",
          color: "red",
          text: this.$t("delete"),
          click: this.remove,
          visibility_condition: this.file_in ? true : false,
        },
      ],
      code: "",
      file_name: "",
      form: undefined,
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.form).form("validate form");

        if (!isValid) reject();
        else {
          local_api(vm, "post", "/api_manager/do-save-file", {
            c: vm.code,
            f: vm.file_name,
          })
            .then(() => {
              vm.$emit("succedded", vm.file_name);
              resolve(vm.file_name);
            })
            .catch((err) => {
              window.jQuery(vm.$refs.form).form("add errors", [err]);
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    remove() {
      let vm = this;
      vm.$alertify.confirm(vm.$t("are you sure to remove file?"), function() {
        local_api(vm, "post", "/api_manager/do-remove-file", {
          f: vm.file_name,
        })
          .then(() => {
            vm.$emit("deleted", vm.file_name);
            window.jQuery(vm.$el).modal("hide");
          })
          .catch((err) => {
            window.jQuery(vm.$refs.form).form("add errors", [err]);
          });
      });
    },
    getData(file) {
      let vm = this;
      local_api(vm, "post", "/api_manager/do-get-file", { f: file })
        .then((data) => {
          vm.code = data;
        })
        .catch((err) => {
          vm.form.form("add errors", [err]);
        });
    },
  },
  mounted() {
    let vm = this;

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();

    vm.form = window.jQuery(vm.$refs.form).form({
      fields: {
        file_name: ["empty"],
        code: ["empty"],
      },
    });

    if (vm.file_in && vm.file_in.file_name) {
      vm.getData(vm.file_in.file_name);
      vm.file_name = vm.file_in.file_name;
    }
  },
  watch: {},
  updated: function() {},
};
</script>
